import { render, staticRenderFns } from "./upgradeTips.vue?vue&type=template&id=5a6aca96&scoped=true&"
import script from "./upgradeTips.vue?vue&type=script&lang=js&"
export * from "./upgradeTips.vue?vue&type=script&lang=js&"
import style0 from "./upgradeTips.vue?vue&type=style&index=0&id=5a6aca96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6aca96",
  null
  
)

export default component.exports